import React, { useState } from "react";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../routes/api/apiRoutes";
import { toast } from "react-toastify";
import OverlayLoader from "../../../components/Common/OverlayLoader";
import { uiRoutes } from "../../../routes/ui/uiRoutes";
import { useNavigate } from "react-router-dom";
const Registerclg = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    mobile_no: "",
    email: "",
    description: "",
    type: "",
    webiste: "",
    student_range: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault(); // ⛔ Prevent default form submission
    callAPI("post", apiRoutes.webiste.collegeRegister, formData);
  };

  if (responce?.data) {
    toast.success("College Register Successfully!");
    setTimeout(() => {
      navigate(uiRoutes.website.home);
    }, 1000);
  }

  return (
    <section className="mt-md-5 pb-5 container">
      <OverlayLoader show={loading} />
      <div className="row">
        {/* Left Side: Background Image */}
        <div className="col-md-6 p-0">
          <div
            className="image-container d-flex flex-column justify-content-center align-items-center p-4 h-100"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <h2
              className="mb-4 text-center"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              College Registration Workflow
            </h2>
            <div className="steps-container w-100">
              {[
                ["fas fa-edit", "Join SysInsight and be Our College Partner"],
                [
                  "fas fa-envelope-open-text",
                  "Admin Verifies & Approves the Request",
                ],
                [
                  "fas fa-user-check",
                  "Check Email for Your Final Confirmation",
                ],
                [
                  "fas fa-sign-in-alt",
                  "Add Students for Exciting Industrial Visits + Internships",
                ],
                [
                  "fas fa-tasks",
                  "Set Visit Dates and Book Your Slot for Internships",
                ],
              ].map(([icon, text], index) => (
                <React.Fragment key={index}>
                  <div className="step-box d-flex align-items-center">
                    <span className="icon-circle">
                      <i className={icon} />
                    </span>
                    <p className="m-0 text-start crl-p">{text}</p>
                  </div>
                  {index < 4 && <div className="arrow">↓</div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>

        {/* Right Side: Registration Form */}
        <div className="col-md-6">
          <div className="singUp-wrap shadow">
            <h2 className="title">Reach Out to Us</h2>
            <span className="val-message">
              {error?.message === "ServerError" && "Internal Server Error"}
            </span>
            <form className="account__form" onSubmit={handleSubmit}>
              <div className="row gutter-20">
                <div className="col-md-12">
                  <div className="form-grp">
                    <label htmlFor="first-name">School/College Name</label>
                    <input
                      type="text"
                      id="first-name"
                      placeholder="School/College Name"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          name: e.target.value,
                        })
                      }
                    />
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.name}{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row gutter-20">
                <div className="col-md-6">
                  <div className="form-grp">
                    <label htmlFor="last-name">Email</label>
                    <input
                      type="text"
                      id="last-name"
                      placeholder="Email"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          email: e.target.value,
                        })
                      }
                    />
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.email}{" "}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-grp">
                    <label htmlFor="last-name">Mobile No</label>
                    <input
                      type="text"
                      id="last-name"
                      placeholder="Mobile No"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          mobile_no: e.target.value,
                        })
                      }
                    />
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.mobile_no}{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row gutter-20">
                <div className="col-md-6">
                  <div className="form-grp">
                    <label htmlFor="email">Type</label>
                    <select
                      className="form-control"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          type: e.target.value,
                        })
                      }
                    >
                      <option value={""}>Select Type</option>
                      <option value={"school"}>School</option>
                      <option value={"college"}>College</option>
                    </select>
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.type}{" "}
                    </span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-grp">
                    <label htmlFor="email">Studnet Range</label>
                    <select
                      className="form-control"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          student_range: e.target.value,
                        })
                      }
                    >
                      <option value={""}>Select Range</option>
                      <option value={"100-200"}>100-200</option>
                      <option value={"300-500"}>300-500</option>
                      <option value={"600-1000"}>600-1000</option>
                    </select>
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.student_range}{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row gutter-20">
                <div className="col-md-6">
                  <div className="form-grp">
                    <label htmlFor="last-name">City</label>
                    <input
                      type="text"
                      id="last-name"
                      placeholder="City"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          city: e.target.value,
                        })
                      }
                    />
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.city}{" "}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-grp">
                    <label htmlFor="last-name">Pincode</label>
                    <input
                      type="text"
                      id="last-name"
                      placeholder="Pincode"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          pincode: e.target.value,
                        })
                      }
                    />
                    <span className="val-message">
                      {error?.message === "ValidationError" &&
                        error?.data?.pincode}{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form-grp">
                <label htmlFor="mobile">Address</label>
                <input
                  type="text"
                  id="mobile"
                  placeholder="Address"
                  onChange={(e) =>
                    setFormData({ ...formData, address: e.target.value })
                  }
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.address}{" "}
                </span>
              </div>
              <button type="submit" className="btn text-white rounded">
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Registerclg;
